import { type PageCalendarEventProps } from './EventTransform';

/** Feed-source values returned by the calendar API (@see CalendarAPI constants). */
export const GOOGLE_FEED_NAME = 'google';
export const ICS_FEED_NAME = 'ics';

/** True when the API-provided link is an internal SmartSites event-view URL. */
const isInternalEventUrl = (url: string | null | undefined): url is string =>
    typeof url === 'string' && /^\/event_view[?/]/.test(url);

/**
 * Resolve the click-through target for a calendar event.
 *
 * Every feed source (native, Google, ICS) is served by the aggregating
 * `/api/calendars/{id}/events` endpoint, which always returns an internal
 * SmartSites `event_view` URL in `link`. Using `link` for all sources keeps
 * Google/ICS events on SmartSites instead of navigating out to the external
 * calendar (SS-4448). Falls back to rebuilding the event-view URL if `link`
 * is ever absent.
 */
export const resolveEventLink = (props: PageCalendarEventProps, eventId: string): string | null => {
    if (isInternalEventUrl(props.link)) {
        return props.link;
    }

    const params = new URLSearchParams({
        event_id: eventId,
        eventDate: props.startDate ?? '',
        calIDref: String(props.calendarId ?? ''),
    });

    return `/event_view?${params.toString()}`;
};
